import { render } from "./FormTags.vue?vue&type=template&id=16b52480"
import script from "./FormTags.vue?vue&type=script&lang=ts"
export * from "./FormTags.vue?vue&type=script&lang=ts"
script.render = render

export default script